import { GitLabScriptInput, PerforceInput, ScenarioInput, TestCaseAlternativeInput, TestCaseInput, TestCaseStepInput, UseCaseInput, UserFunctionInput, VehicleFunctionInput, VehicleFunctionBaseInput, ArpyLinkInput } from "../models/input/graphql-test-case-input";
import { TestCaseDto } from "src/app/models/dto/testCaseDto";
import { TestCaseAlternativeDto } from "src/app/models/dto/testCaseAlternativeDto";
import { GitLabScriptDto } from "src/app/models/dto/gitLabScriptDto";
import { StepDto } from "src/app/models/dto/stepDto";
import { Scenario, UseCase, UserFunction } from "src/app/models/dto/user-function-dto";
import { VehicleFunction, VehicleFunctionBase } from "src/app/models/dto/vehicleFunctionDto";
import { PerforceScriptDto } from "src/app/models/dto/perforceScriptDto";
import { ArpyLinkRefDto } from "src/app/models/dto/arpy/arpyLinkDto";

import { oldApiSearchIdentity } from "./common.mappers";
  export function convertTestCaseDtoToGraphqlInput(input: TestCaseDto): TestCaseInput {
    return {
      Uid: input.uid ?? '',
      ...oldApiSearchIdentity(input),
      Version: input.version,
      ModifiedBy: input.modifiedBy,
      ModificationTime: null, //input.ModificationTime,
      Comment: input.comment,
      LockedBy: input.lockedBy,
      LockedTime: null, //input.lockedTime ? input.lockedTime.toISOString() : null,
      CreatedBy: input.createdBy,
      CreationTime: null, //  input.creationTime ? new Date(new Date(input.creationTime + 'Z').toLocaleString()).toDateString() : null,
      ApprovalStatus: input.approvalStatus,
      ApprovedForTestLevel: input.approvedForTestLevel,
      Label: input.label,
      InputTypeName: input.inputTypeName,
      InputTypeValues: input.inputTypeValues,
      DerivedFrom: input.derivedFrom,
      DetailLevel: input.detailLevel,
      RestrictedViewAccess: input.restrictedViewAccess,
      TestType: input.testType,
      ObjectUnderTestType: input.objectUnderTestType,
      OwnerIds: input.ownerIds,
      EcuIds: input.ecuIds,
      OffboardComponentIds: input.offboardComponentIds,
      ProductPropertyIds: input.productPropertyIds,
      UserFunctions: input.userFunctions?.map(item => {
        return convertUserFunctionToGraphqlInput(item)
      }),
      VehicleFunctions: input.vehicleFunctions?.map(item => {
        return convertVehicleFunctionToGraphqlInput(item)
      }),
      ArpyLinks: input.arpyLinks?.map(item => {
        return convertArpyLinkToGraphqlInput(item)
      }),
      Description: input.description,
      Tags: input.tags,
      Alternative: input.alternative ? convertTestCaseAlternativeDtoToGraphqlInput(input.alternative) : undefined,
      Steps: input.steps?.filter(item => !!item.no).map(item => {
        return convertStepDtoToGraphqlInput(item)
      })
    }
  }

  export function convertTestCaseAlternativeDtoToGraphqlInput(input: TestCaseAlternativeDto ): TestCaseAlternativeInput  {
    return{
      Uid: input.uid,
      Environment: input.environment,
      Fpc: input.fpc,
      Tpc: input.tpc,
      TestGroups: input.testGroups,
      TestObjects: input.testObjects,
      GitLabScript: input.gitLabScript?.map(item => {
        return convertGitLabScriptDtoToGraphqlInput(item);
      }),
      PerforceScripts: input.perforceScripts?.map(item => {
        return convertPerforceScriptDtoToGraphqlInput(item);
      }),
    }
  }

  export function convertGitLabScriptDtoToGraphqlInput(input: GitLabScriptDto ): GitLabScriptInput  {
    return{
      Name: input.name,
      Path: input.path,
      ForeignSystemKey: input.foreignSystemKey,
    }
  }

    export function convertPerforceScriptDtoToGraphqlInput(input: PerforceScriptDto ): PerforceInput  {
    return{
      Path: input.path,
      Name: input.name,
      Status: input.status,
    }
  }


  export function convertStepDtoToGraphqlInput(input: StepDto ): TestCaseStepInput  {
    return{
      No: input.no,
      PreCondition: { Key: input.preCondition.key, Value: input.preCondition.value },
      Stimuli: { Key: input.stimuli.key, Value: input.stimuli.value },
      ExpectedResponse: { Key: input.expectedResponse.key, Value: input.expectedResponse.value },
      PostCondition: { Key: input.postCondition.key, Value: input.postCondition.value },
    }
  }


  /**
   * Parse User Function name to extract ID if it follows UF pattern
   * Handles: 'UF 8:name', 'UF:8 name', 'UF8:name', 'UF9', 'UF 8', etc.
   */
  function parseUserFunctionName(name: string): { id: number; name: string } {
    const trimmed = name.trim();

    // Pattern: UF<optional separator><number><optional separator + name>
    const withNumberPattern = /^UF[\s_:]*(\d+)(?:[\s_:]+(.+))?$/i;
    const match = trimmed.match(withNumberPattern);

    if (match) {
      const id = parseInt(match[1], 10);
      const parsedName = match[2] ? match[2].trim() : '';
      return { id, name: parsedName };
    }

    // No UF prefix or pattern - return as-is
    return { id: -1, name: trimmed };
  }

  export function convertUserFunctionToGraphqlInput(input: UserFunction ): UserFunctionInput  {
    // If id is -1, try to parse the name for UF pattern
    let finalId = input.id;
    let finalName = input.name;

    if (input.id === -1) {
      const parsed = parseUserFunctionName(input.name);
      finalId = parsed.id;
      finalName = parsed.name;
    }

    return{
      Id: finalId,
      Name: finalName,
      UseCases: input.useCases?.map(x => {
        return convertUseCaseToGraphqlInput(x);
      })
    }
  }

  export function convertUseCaseToGraphqlInput(input: UseCase ): UseCaseInput  {
    return{
      Id: input.id,
      Name: input.name,
      Scenarios: input.scenarios?.map(x => {
        return convertScenarioToGraphqlInput(x);
      })
    }
  }

  export function convertScenarioToGraphqlInput(input: Scenario ): ScenarioInput  {
    return{
      Id: input.id,
      Name: input.name,
    }
  }

  export function convertVehicleFunctionToGraphqlInput(input: VehicleFunction ): VehicleFunctionInput  {
    return{
      Id: input.id,
      Name: input.name,
      Revision: input.revision,
      VehicleSubFunctions: input.vehicleSubFunctions?.map(x => {
        return convertVehicleSubFunctionToGraphqlInput(x);
      })
    }
  }

  export function convertVehicleSubFunctionToGraphqlInput(input: VehicleFunctionBase ): VehicleFunctionBaseInput  {
    return{
      Id: input.id,
      Name: input.name,
      Revision: input.revision,
    }
  }

  export function convertArpyLinkToGraphqlInput(input: ArpyLinkRefDto ): ArpyLinkInput  {
    return{
      Uid: input.uid,
      Type: input.type,
      ParentUid: input.parentUid,
      GrandParentUid: input.grandParentUid,
      FileVersion: input.fileVersion,
    }
  }
